<template>
	<div class="list_menu">
		<div
			class="list_menu_item"
			v-for="(item, index) in listNameArr"
			:key="index"
			@click="doneRefresh(index, item)"
		>
			<div
				:class="{ active: currentIdx == index }"
				class="list_menu_ite_text"
			>
				{{ item.name }}
			</div>
			<div class="imgs" v-if="index > 1">
				<img
					v-if="item.showDESC == '1'"
					class="upImg"
					style="width: 6.59px; height: 3.79px; margin-left: 5px"
					src="@/assets/select_up.jpg"
				/>
				<img
					v-else
					class="upImg"
					style="width: 6.59px; height: 3.79px; margin-left: 5px"
					src="@/assets/normal_up.jpg"
				/>
				<img
					v-if="item.showDESC == '0'"
					class="downImg"
					style="width: 6.59px; height: 3.79px; margin-left: 5px"
					src="@/assets/select_down.jpg"
				/>
				<img
					v-else
					class="downImg"
					style="width: 6.59px; height: 3.79px; margin-left: 5px"
					src="@/assets/normal_down.jpg"
				/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			// "最新", "推荐", "热度", "最赚", "价格"
			listNameArr: [],
			currentIdx: 0,
			isShowDESC: 2, //0-DESC，1-ASC
		}
	},
	mounted() {
		this.listNameArr = [
			{ name: '最新', showDESC: '2', sortFiled: '5' }, //默认请求全部
			{ name: '推荐', showDESC: '2', sortFiled: '4' },
			{ name: '热度', showDESC: '2', sortFiled: '0' },
			{ name: '价格', showDESC: '2', sortFiled: '2' },
		]
		// if (this.$store.getters.identityDeal) {
		// 	this.listNameArr = [
		// 		{ name: '最新', showDESC: '2', sortFiled: '5' }, //默认请求全部
		// 		{ name: '推荐', showDESC: '2', sortFiled: '4' },
		// 		{ name: '热度', showDESC: '2', sortFiled: '0' },
		// 		{ name: '价格', showDESC: '2', sortFiled: '2' },
		// 	]
		// } else {
		// 	this.listNameArr = [
		// 		{ name: '最新', showDESC: '2', sortFiled: '5' }, //默认请求全部
		// 		{ name: '推荐', showDESC: '2', sortFiled: '4' },
		// 		{ name: '热度', showDESC: '2', sortFiled: '0' },
		// 		{ name: '最赚', showDESC: '2', sortFiled: '1' },
		// 		{ name: '价格', showDESC: '2', sortFiled: '2' },
		// 	]
		// }
	},
	methods: {
		//菜单选择刷新
		doneRefresh(index, item) {
			// this.isShowDESC = 2; //排序置空
			if (this.currentIdx != index) {
				this.listNameArr[this.currentIdx].showDESC = '2'
				this.currentIdx = index
			}
			if (this.listNameArr[this.currentIdx].showDESC == '2') {
				this.listNameArr[this.currentIdx].showDESC = '0'
			} else if (this.listNameArr[this.currentIdx].showDESC == '0') {
				this.listNameArr[this.currentIdx].showDESC = '1'
			} else if (this.listNameArr[this.currentIdx].showDESC == '1') {
				this.listNameArr[this.currentIdx].showDESC = '0'
			}

			this.$emit('doneRefresh', this.listNameArr[this.currentIdx])
		},
	},
}
</script>

<style lang="scss" scoped>
.list_menu {
	padding-top: vw(20) vw(48) 0 vw(48);
	background-color: #ffffff;
	height: vw(80);
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	.list_menu_item {
		flex: 1;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		.list_menu_item_text {
			color: #333333;
			font-size: vw(26);
		}
		.imgs {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}
		.upImg {
		}
		.downImg {
			margin-top: vw(4);
		}
		.active {
			color: #3377ff;
		}
	}
}
</style>
